import { ChevronsRight } from "lucide-react";
import type { FC } from "react";

import type { OperationDetails, TokensList } from "../../../model";
import { TokenList } from "../TokenList";

export interface DetailsProps {
  data: OperationDetails;
  tokens: TokensList;
}

export const Details: FC<DetailsProps> = ({ data, tokens }) => {
  const { from, to, leverage } = data;
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <div className="min-w-0 flex-shrink">
        <TokenList data={from} tokens={tokens} />
      </div>
      {to && (
        <div className="relative mx-2 flex-shrink-0">
          {leverage && (
            <div className="absolute left-1/2 -translate-x-1/2 -top-3 text-[10px] font-bold">
              x{leverage}
            </div>
          )}
          <ChevronsRight size={14} className="text-gray-400" />
        </div>
      )}
      {to && (
        <div className="min-w-0 flex-shrink">
          <TokenList data={to} tokens={tokens} />
        </div>
      )}
    </div>
  );
};
